import { Outlet } from 'react-router-dom';

// ==============================|| CHAT LAYOUT ||============================== //

const ChatLayout = () => (
  <div style={{ height: '100vh', width: '100vw', overflow: 'hidden' }}>
    <Outlet />
  </div>
);

export default ChatLayout;
